export const Colors = {
  secondary: "#204e33",
  primary: "#204e33",
  lightGrey: "#bebebe",
  white: "#fff",
  grey: "#6a6a6a",
  black: "#1d1d1d",
  inputGrey: "#EBEBEB",
};
